import Sentence from "../model/Sentence";
import SentenceHistory from "../model/SentenceHistory";
import { getUid } from "../../auth/AuthManager";
import {
  getLanguageCode,
  getLanguageString,
} from "../manager/sentenceSettings";
import getApiInstance from "../../common/api";
import OnevocaServerError from "../../common/OnevocaServerError";

async function requestSentence(
  path: string,
  word: string,
  specificWordLanguage: string
): Promise<Sentence> {
  try {
    const uid = await getUid();
    const languageCode = getLanguageCode();
    const languageString = getLanguageString();

    const response = await getApiInstance(undefined).get(
      `${path}?uid=${uid}&requestWord=${word}&requestLanguage=${languageCode}&requestLanguageLocalizedString=${languageString}&specificWordLanguage=${specificWordLanguage}`
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    }

    const result = response.data.result;

    if (result === undefined) {
      return Promise.reject("No data.");
    }

    const sentence = Sentence.fromJson(result);
    return sentence;
  } catch (error) {
    return Promise.reject(error);
  }
}

/** history 를 넘기면 받은 예문을 기록해 이후 '다른 예문 보기'에서 제외한다. */
export async function fetchSentence(
  word: string,
  specificWordLanguage: string,
  history?: SentenceHistory
): Promise<Sentence> {
  const sentence = await requestSentence(
    "/sentence/requestMakeSentence.php",
    word,
    specificWordLanguage
  );
  history?.append(word, sentence.sentence);
  return sentence;
}

/**
 * 구독자 전용. 비구독자에게는 서버가 에러 10000을 돌려준다.
 * 이미 받은 예문을 previous_sentences 로 함께 보내 같은 예문이 다시 나오지 않게 한다.
 */
export async function fetchMoreSentence(
  word: string,
  specificWordLanguage: string,
  history: SentenceHistory
): Promise<Sentence> {
  try {
    const uid = await getUid();
    const parameters: Record<string, unknown> = {
      uid: uid,
      requestWord: word,
      requestLanguage: getLanguageCode(),
      requestLanguageLocalizedString: getLanguageString(),
      specificWordLanguage: specificWordLanguage,
    };

    const previousSentences = history.sentences(word);
    if (previousSentences.length !== 0) {
      parameters.previous_sentences = previousSentences;
    }

    const response = await getApiInstance(undefined).post(
      "/sentence/getMoreSentence.php",
      parameters
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    }

    const result = response.data.result;

    if (result === undefined) {
      return Promise.reject("No data.");
    }

    const sentence = Sentence.fromJson(result);
    history.append(word, sentence.sentence);
    return sentence;
  } catch (error) {
    return Promise.reject(error);
  }
}
